import * as React from 'react';
import { observer } from 'mobx-react';
import { AiOutlineDelete, AiOutlineForm } from 'react-icons/ai';
import AgentStore from '../../../stores/AgentStore';
import style from './AgentPanel.module.scss';

interface HistoryListProps { agentStore: AgentStore; }

@observer
export class HistoryList extends React.Component<HistoryListProps> {
  render() {
    const { agentStore } = this.props;
    const threads = agentStore.threads.filter((thread) => thread.title);
    return <div className={style.history}>
      <button type="button" className={style.newThread} onClick={() => agentStore.newThread()}>
        <AiOutlineForm /> 새 대화
      </button>
      {threads.length === 0 && <div className={style.notice}>지난 대화가 없습니다.</div>}
      {threads.map((thread) => <div key={thread.id} className={style.historyRow}>
        <button type="button" title={thread.title} onClick={() => agentStore.openThread(thread.id)}>{thread.title}</button>
        <button
          type="button"
          className={style.iconButton}
          title="대화 지우기"
          aria-label={`${thread.title} 지우기`}
          onClick={() => agentStore.deleteThread(thread.id)}
        >
          <AiOutlineDelete />
        </button>
      </div>)}
    </div>;
  }
}
